import React, { FormEvent, Fragment, useContext, useEffect, useState } from "react";
import { Table, Container, Tab, Menu, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TimeSheetStore from "../../../app/stores/timesheetStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TimeSheetReviewForm from "./TimeSheetReviewForm";
import TimeSheetInputForm from "./TimeSheetInputForm";

const TimeSheetDashboard: React.FC = () => {
  const timesheetStore = useContext(TimeSheetStore);
  const { clearPage, loadEmployees, loadPayrollCycles, loadProjectTimes, loadingInitial, submitting, target } = timesheetStore;

  useEffect(() => {
    setActiveItem("Review");
    
    return () => {
      clearPage();
    };
  }, []);

  const [activeItem, setActiveItem] = useState("");

  return (
    <Container fluid> 
      <Menu widths={2} pointing attached='top'>
        <Menu.Item
          name='Review'
          active={activeItem === 'Review'}
          onClick={(e, {name}) => {setActiveItem(name!.toString());}}
        >
         { (activeItem === 'Review') ? <strong style={{fontSize: 16}}>Review</strong> : 
         <span style={{fontSize: 16}}>Review</span>}
        </Menu.Item>
        <Menu.Item
          name='Input'
          active={activeItem === 'Input'}
          onClick={(e, {name}) => {setActiveItem(name!.toString());}}
        >
          { (activeItem === 'Input') ? <strong style={{fontSize: 16}}>Input</strong> : 
         <span style={{fontSize: 16}}>Input</span>}
        </Menu.Item>
      </Menu>
      <Segment attached='bottom'>
          {(activeItem === 'Review') ? <TimeSheetReviewForm/> : (activeItem === 'Input') ? <TimeSheetInputForm/> : ''}
        </Segment>
    </Container>
  );
};

export default observer(TimeSheetDashboard);
